import {
    TableRow,
    TableCell
} from "@/components/ui/table";
import { ChevronDown, ChevronRight, Check, X } from "lucide-react";
import { useState, useEffect } from "react";
import { DateTime } from "luxon";
import ProspectCard from "../CommunityPages/SecretShopper/ProspectCard.jsx";
import LogsCard from "../CommunityPages/SecretShopper/LogsCard.jsx";
import axios from "@/lib/axios";
import { toast } from "@/hooks/use-toast.js";

const SecretShopperReportRow = ({ secretShopper, initiateCallback = () => { } }) => {
    const [isOpen, setIsOpen] = useState(false);
    const [isLoading, setIsLoading] = useState(false);
    const [logs, setLogs] = useState([]);
    const [metrics, setMetrics] = useState({});

    const community = {
        id: secretShopper.community_id,
        community_name: secretShopper.community_name,
        community_phone_number: secretShopper.community_phone_number,
        assigned_flair_phone_number: secretShopper.assigned_flair_phone_number,
        time_zone: secretShopper.time_zone,
    };

    useEffect(() => {
        if (!isOpen || !secretShopper?.id) {
            return;
        }

        const fetchData = async () => {
            setIsLoading(true);
            try {
                const { data } = await axios.get(`/secret-shopper/${secretShopper.id}/logs`);
                setLogs(data.logs || []);
                setMetrics(data.metrics);
            } catch (error) {
                toast({ title: "Error fetching data", variant: "destructive" });
            } finally {
                setIsLoading(false);
            }
        };

        fetchData();
    }, [isOpen, secretShopper]);

    const formattedDate = DateTime.fromISO(secretShopper.created_at).toFormat("MMM dd, yyyy");
    const isActive = !!secretShopper.is_active;


    return (
        <>
            <TableRow
                onClick={() => setIsOpen((prev) => !prev)}
                className={`cursor-pointer hover:bg-muted/50 h-20 ${isOpen ? "border-b-0" : ""}`}
            >
                <TableCell>
                    {isOpen
                        ? <ChevronDown className="h-5 w-5 text-muted-foreground" />
                        : <ChevronRight className="h-5 w-5 text-muted-foreground" />}
                </TableCell>

                <TableCell className="font-medium w-5 max-w-5 truncate">{secretShopper.community_name}</TableCell>
                <TableCell>{formattedDate}</TableCell>

                {/* ✔︎ / ✕ columns */}
                <TableCell className="p-2 align-middle text-center">
                    <div className="flex justify-center items-center h-full">
                        {secretShopper.coverage?.call
                            ? <Check className="text-green-600" />
                            : <X className="text-red-500" />}
                    </div>
                </TableCell>
                <TableCell className="p-2 align-middle text-center">
                    <div className="flex justify-center items-center h-full">
                        {secretShopper.coverage?.text
                            ? <Check className="text-green-600" />
                            : <X className="text-red-500" />}
                    </div>
                </TableCell>
                <TableCell className="p-2 align-middle text-center">
                    <div className="flex justify-center items-center h-full">
                        {secretShopper.coverage?.email
                            ? <Check className="text-green-600" />
                            : <X className="text-red-500" />}
                    </div>
                </TableCell>
                <TableCell className="p-2 align-middle text-center">
                    <div className="flex justify-center items-center h-full">
                        {secretShopper.coverage?.voicemail
                            ? <Check className="text-green-600" />
                            : <X className="text-red-500" />}
                    </div>
                </TableCell>

                <TableCell className="text-center">
                    <span
                        className={`px-2 py-1 text-xs font-medium rounded-full
        ${isActive ? "bg-green-100 text-green-700" : "bg-gray-100 text-gray-600"}`}
                    >
                        {isActive ? "Active" : "Closed"}
                    </span>
                </TableCell>
            </TableRow>

            {isOpen && (
                <tr className="border-b">
                    <td colSpan={8} className="p-4">
                        <div className="space-y-5">
                            <ProspectCard
                                isLoading={isLoading}
                                logs={logs}
                                secretShopperData={secretShopper}
                                community={community}
                                metrics={metrics}
                                initiateCallback={() => initiateCallback(secretShopper)}
                            />
                            <LogsCard logs={logs} community={community} secretShopper={secretShopper} isLoading={isLoading} />
                        </div>
                    </td>
                </tr>
            )}
        </>
    );
};

export default SecretShopperReportRow;
